import { features } from 'reactApp/mail-features';

export const allowUploadAtOverquota: boolean = features.has('overquota-upload-allow');

export const enableQuotaBeforeUserLimitCheck = features.has('enable-quota-before-user-limit-check');

export const enableQuotaNoSizeCheck = features.has('enable-quota-no-size-check');
